import styled from 'styled-components';

export const StarandReview = styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0 8px;
  position: relative;
  justify-content: space-between;
  background-color: #f7f6f6;
  padding: 4px 8px;
  border-radius: 8px;
  @media (min-width: 768px) {
    cursor: pointer;
    background-color: #fff;
    padding: 0;
    border-radius: 0;
  }
  .ratingContainer {
    display: flex;
    align-items: center;
  }
`;

export const ProdRatingStar = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;

  li {
    margin-right: 4px;

    img,
    svg {
      width: ${(props) => props.width};
      height: ${(props) => props.height};

      @media (max-width: 720px) {
        width: ${(props) => (props.cartFiller ? '12px' : '18px')};
        height: ${(props) => (props.cartFiller ? '12px' : '18px')};
      }
    }
  }
`;
export const SharePopup = styled.div`
  height: 35vh;
  position: absolute;
  bottom: 0;
  background-color: #fff;
`;
export const TotalReview = styled.div`
  margin-left: 6px;
  font-size: ${(props) => props.fontS};
  color: hsl(0deg, 0%, 0%, 80%);

  @media (max-width: 720px) {
    font-size: 14px;
  }
`;

export const RatingDiv = styled.div`
  display: flex;
  margin-left: 4px;
  align-items: center;
`;

export const TotalRating = styled.span`
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 80%);
`;

export const RatingCount = styled.span`
  padding: 0 4px;
  color: hsl(0deg 0% 0% / 60%);
  font-size: ${(props) => props.size || '14px'};
  font-weight: 500;
  border-left: ${(props) => props.seperator};
  @media (min-width: 720px) {
    font-size: ${(props) => (props.size ? '0.9em' : '14px')};
  }
`;

export const ReadReviewsStyle = styled.div`
  text-decoration: underline;
  font-size: 0.75em;
  color: hsl(0deg, 0%, 0%, 80%);
  font-weight: 600;
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  opacity: ${(props) => (props.lowOpacity ? '0.6' : '1')};
  @media (min-width: 720px) {
    font-size: 0.9em;
  }
`;
